module.exports = __webpack_public_path__ + "img/w3_pause_light.1b7d3e5d.png";